/** @format */

import React from 'react';
import SyncLoader from 'react-spinners/SyncLoader';
import './styles.scss';

/**
 * Custom loader animation element for button
 *
 * @param {*} props
 * @returns JSX
 *
 * @author Sandun Munasinghe
 * @since 22-08-2022
 */
export default function ButtonSyncLoader(props) {
  const className = props.className ? props.className : '';
  return (
    <div className={`button-loader ${className} `}>
      <SyncLoader
        color={props.color ? props.color : 'var(--color-primary-pink)'}
        loading={true}
        className='button-loader'
        size={6}
      />
    </div>
  );
}

export const LoaderButton = (props) => {
  const { text, display } = props;
  if (display) {
    return (
      <span className='loader-button btn btn-white btn btn-primary'>
        <ButtonSyncLoader /> {text}
      </span>
    );
  }

  return <></>;
};
